import { CompassCardUI } from '@scale/compass-ui/types';
import { WorkerTeamEventType } from '@scale/shared/types/events/WorkerTeamEvent';
import {
  type MoveWorkerTeamSchemaType,
  type MoveWorkerTeamContext,
  MoveWorkerTeamCardShared,
  MOVE_WORKER_TEAM,
} from '@scale/genai-compass-shared/cards/move_worker_team';
import MoveWorkerTeamCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/MoveWorkerTeamCard/MoveWorkerTeamCardComponent';
import { faUsersSlash } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: MoveWorkerTeamContext = {
  cardType: MOVE_WORKER_TEAM,
  autopermission: true,
  eventType: WorkerTeamEventType.AddWorker,
  dryRun: true,
};

export const MoveWorkerTeamCardInfo: CompassCardUI<MoveWorkerTeamSchemaType> = {
  ...MoveWorkerTeamCardShared,
  title: 'Move Worker Team',
  icon: 'swap',
  toolTip: 'Move workers from current team to a new team.',
  defaultContext,
  showOutput: true,
  legacyComponent: MoveWorkerTeamCardComponent,
  button: {
    icon: faUsersSlash,
  },
};
